import { render, staticRenderFns } from "./JobSummaryItem.vue?vue&type=template&id=080a94d6&scoped=true&"
import script from "./JobSummaryItem.vue?vue&type=script&lang=js&"
export * from "./JobSummaryItem.vue?vue&type=script&lang=js&"
import style0 from "./JobSummaryItem.vue?vue&type=style&index=0&id=080a94d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a94d6",
  null
  
)

export default component.exports